/*
 * @Author: cui
 * @Date: 2020-08-03
 * */

export default {
  isLogin: (state) => (state.token ? true : false),
};
